module.exports = __webpack_public_path__ + "assets/bullet.d3db03d0.svg";